<template>
    <div>
        <div class="label">
            {{label}}
        </div>
        <div class="input-container">
            <div class="day">
                <label :for="id+'day'">Jour</label>
                <input type="number"
                       :id="id+'day'"
                       v-model="date.day"
                       @input="isValidDate"
                       min="1"
                       max="31"
                       step="1"
                       ref="day"
                       placeholder="01"

                >
            </div>
            <div class="month">
                <label :for="id+'month'">Mois</label>
                <input type="number"
                       :id="id+'month'"
                       v-model="date.month"
                       @input="isValidDate"
                       min="1"
                       max="12"
                       step="1"
                       ref="month"
                       placeholder="01"
                >
            </div>
            <div class="year">
                <label :for="id+'year'">Année</label>
                <input type="number"
                       :id="id+'year'"
                       v-model="date.year"
                       @input="isValidDate"
                       step="1"
                       ref="year"
                       placeholder="2000"

                >
            </div>
        </div>
        <validation-provider :rules="rules"
                             v-slot="{ errors, classes }"
                             class="real-input"
        >
            <input id="realInput" ref="realInput" type="text" readonly="readonly" tabIndex="-1" v-model="date.fullDate">
            <span class="span-error"> {{ errors[0] }}</span>
        </validation-provider>
    </div>
</template>

<script>
    import {ValidationProvider} from 'vee-validate'

    export default {
        name: "InputBirthday",
        components: {ValidationProvider},
        props: {
            id: [String, Number],
            val: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: 'Date de naissance'
            },
            rules: {
                type: String,
                default: 'required|major'
            }
        },
        data() {
            return {
                date: {
                    day: '',
                    month: '',
                    year: '',
                    fullDate: '',
                },
                maxDay: 31,
                hasCompleteInputDay: false,
                hasCompleteInputMonth: false,
                hasCompleteInputYear: false,
                hasCompleteAllInputs: false,
            }
        },
        mounted() {
            this.date.fullDate = this.val
        },
        methods: {
            hasComplete(el) {
                if (this.hasCompleteAllInputs)
                    return
                switch (el) {
                    case 'day':
                        if (!this.hasCompleteInputDay)
                            this.hasCompleteInputDay = true
                        break;
                    case 'month':
                        if (!this.hasCompleteInputMonth)
                            this.hasCompleteInputMonth = true
                        break;
                    case 'year':
                        if (!this.hasCompleteInputYear)
                            this.hasCompleteInputYear = true
                        break;
                }
                if (this.hasCompleteInputDay && this.hasCompleteInputMonth && this.hasCompleteInputYear) {
                    this.hasCompleteAllInputs = true
                }

            },
            isValidDate() {
                let day = Number(this.date.day),
                    month = Number(this.date.month),
                    year = Number(this.date.year);

                if (this.date.year.length === 4 && this.date.month && this.date.day) {
                    let date = new Date(this.date.year + '/' + this.date.month + '/' + this.date.day)
                    if (date instanceof Date && !isNaN(date)) {
                        this.date.fullDate = date
                        this.$emit('input', date)
                    } else {
                        this.date.fullDate = ''
                        this.$emit('input', date)
                    }
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .input-container {
        margin-bottom: 16px;

        > div {
            display: inline-block;

            label {
                transform: translate(8px, 10px);
                display: table-cell;
                background: white;
                font-size: .85rem;
            }
        }
    }

    input {
        outline: none;
        border: 1px solid var(--color-grey-light-1);
        padding: 14px var(--s-xs);
        font-size: 1rem;
        line-height: 1rem;
        margin-right: 16px;
        border-radius: var(--radius-default);
        text-align: center;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance: textfield; /* Firefox */
    }

    .day, .month {
        input {
            width: 48px;
        }
    }

    .year {
        input {
            width: 84px;
        }
    }

    #realInput {
        opacity: 0;
        height: 1px;
        padding: 0;
        margin: 0;
        border: none;
        display: block;
    }
</style>
